import { IDeleteEntity } from "interfaces/delete-entity";
import { GraphQLData } from "interfaces/graphql-data";
import { ITenant } from "interfaces/tenant";

export class DeleteApiUserModel implements IDeleteEntity, GraphQLData {
  lastEvaluatedKey: string = '';
  deleted: boolean = false;

  public static create(
    deleted: boolean) : DeleteApiUserModel {
    const t = new DeleteApiUserModel();
    t.deleted = deleted;
    return t;
  }

  async hydrate(data: any, tenant: ITenant): Promise<void> {
    //..
    // data.data.GetTenant.Deleted (true)
    console.log(data);
    if (data && data.data && data.data.GetApiUser && data.data.GetApiUser.Delete) {
      this.deleted = data.data.GetApiUser.Delete;
    } else {
      throw new Error('data structured passed in does not contain data, data.data, data.data.GetApiUser or data.data.GetApiUser.Delete');
    }
  }
}